import React, { useId } from 'react';
import MapIcon from '@mui/icons-material/MapOutlined';

import { Card } from 'src/component/ds/ui/card';
import { Switch } from 'src/component/ds/ui/switch';
import { cn } from 'src/component/ds/utils';
import { useTranslation } from 'src/i18n';

export interface MapModeToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
}

export default function MapModeToggle ({ checked, onCheckedChange, className }: MapModeToggleProps) {
  const { t } = useTranslation();
  const id = useId();

  return (
    <Card className={cn('ds-shadow-sm', className)} data-testid='map-mode-toggle'>
      <div className='ds-flex ds-items-center ds-gap-2 ds-p-4'>
        <label htmlFor={id} className='ds-flex ds-cursor-pointer ds-text-[2.4rem] ds-text-muted-foreground'>
          <MapIcon fontSize='inherit' />
          <span className='ds-sr-only'>{t('dashboard.mapModeLabel')}</span>
        </label>
        <Switch
          id={id}
          checked={checked}
          onCheckedChange={onCheckedChange}
          data-testid='map-mode-switch'
        />
      </div>
    </Card>
  );
}
